import { Link } from "react-router-dom"

const Header = ({ text }) => {
    return (
        <section className="headerSection">
            <Link to="/">
                <img src="icons/forescout-research-vedere-labs-white.svg" alt="Vedere Labs logo" className="white-logo" />
            </Link>
            <h1 className="pageTitle">{text}</h1>
        </section>
    )
}

export default Header